'use client';

import { MenuItem, MenuSeparator } from '@headlessui/react';
import clsx from 'clsx';
import React, { Fragment } from 'react';

export type DropdownItemProps = {
	separator?: boolean;
	text?: string;
	icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
	onClick?: () => void;
	// href?: string;
	selected?: boolean;
	disabled?: boolean;
};

export const DropdownItem = ({
	separator,
	text,
	icon: Icon,
	selected,
	...props
}: DropdownItemProps) => {
	if (separator) {
		return <MenuSeparator className="my-1 h-px bg-gray-100" />;
	}

	const cn = clsx(
		'flex w-full items-center rounded-lg px-3 py-2 text-left text-sm data-[disabled]:bg-gray-5 data-[focus]:bg-gray-5 data-[selected]:bg-gray-5 data-[disabled]:opacity-70',
		{
			'bg-gray-5': selected,
		},
	);
	return (
		<MenuItem as={Fragment} disabled={props.disabled}>
			<button className={cn} {...props}>
				{Icon && <Icon className="mr-2 size-4" />}
				{text}
			</button>
		</MenuItem>
	);
};
